import { Component, Input, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { InputComponent } from '../../../core/controls/input.component';

@Component({
  selector: 'app-days-option',
  imports: [InputComponent],
  template: `
    <div class="tw-col-span-2 tw-flex" role="group" [attr.aria-labelledby]="labelId">
      <span class="label tw-grow tw-font-bold tw-pt-2" [id]="labelId">{{ label }}</span>
      <app-input type="Integer" [control]="control" [max]="99999" label="Days"></app-input>
    </div>
  `,
  styles: ``,
})
export class DaysOptionComponent implements OnInit {
  protected labelId = 'days-option-' + Math.trunc(Math.random() * 100000);

  @Input()
  control: FormControl<number>;

  @Input()
  label: string;

  async ngOnInit() {
    this.control.addValidators([
      Validators.required,
      Validators.min(0),
      Validators.max(99999),
    ]);
    if (this.control.value == null) {
      this.control.setValue(30);
    }
    this.control.updateValueAndValidity({ emitEvent: false });
  }
}
